import { ThunkType } from "../../../../core/store/reducers";
import { getChartData } from "../api/getChartData";
import { setGraphData } from "../tickerDataSlice";
import { ChartPeriod } from "../types";

export const loadGraphData = (graphId: string, secid: string, period: ChartPeriod): ThunkType => async (dispatch, getStore) => {
	const store = getStore();

	if (store.data.auth.current.status !== "successful" || !secid) {
		return;
	}

	const { user } = store.data.auth.current;
	const graphData = await dispatch(getChartData(user, secid, period));

	dispatch(
		setGraphData({
			graphId: graphId,
			data: graphData || [],
		})
	);
};

